import Vue from "vue";
import Vuex from "vuex";

import { app } from "@/store/modules/app";
import { appointments } from "@/store/modules/appointments";
import { auth } from "@/store/modules/auth";
import { chat } from "@/store/modules/chat";
import { checkout } from "@/store/modules/checkout";
import { encounters } from "@/store/modules/encounters";
import { invites } from "@/store/modules/invites";
import { patient } from "@/store/modules/patient";
import { patients } from "@/store/modules/patients";
import { practitioners } from "@/store/modules/practitioners";
import { profileSettings } from "@/store/modules/profileSettings";
import { slots } from "@/store/modules/slots";
import { videoRoom } from "@/store/modules/videoRoom";
import { visitNote } from "@/store/modules/visitNote";
import { RootState } from "@/types";

import user from "./modules/user";

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  modules: {
    app,
    auth,
    user,
    visitNote,
    invites,
    patients,
    appointments,
    encounters,
    videoRoom,
    slots,
    checkout,
    patient,
    profileSettings,
    practitioners,
    chat,
  },
});
